import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import AnimatedLogo from "../AnimatedLogo/AnimatedLogo";
import logo from "../../Assets/logo/logo2.0.webp";
import NavbarButton from "../NavbarButton/NavbarButton";
import "./Navbar.css";
import { Link } from "react-router-dom";

const Navigationbar = () => {
  return (
    <Navbar expand="lg" className="fixed-top white-back">
      <Navbar.Brand href="/">
        <img src={logo} height={75} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="" />
      <Navbar.Collapse id="" className="nvbar">
        <Nav className="ml-auto">
          <Nav.Link as={Link} to="/">
            <NavbarButton props={"Home"} />
          </Nav.Link>

          <Nav.Link as={Link} to="/vision" className="aboutus">
            <NavbarButton props={"About us"} />
          </Nav.Link>

          <Nav.Link as={Link} to="/projects">
            <NavbarButton props={"Projects"} />
          </Nav.Link>

          <Nav.Link as={Link} to="/contact">
            <NavbarButton props={"Contact Us"} />
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
export default Navigationbar;
